namespace TabAurous.Stock {
    export namespace JewelleryTagSheet2Service {
        export const baseUrl = 'Stock/JewelleryTagSheet2';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function StoneFilter(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/JewelleryTagSheet2/List",
            StoneFilter = "Stock/JewelleryTagSheet2/StoneFilter"
        }

        [
            'List', 
            'StoneFilter'
        ].forEach(x => {
            (<any>JewelleryTagSheet2Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
